import axios, { AxiosResponse } from "axios";
import { IMessage } from "../models/chat_models"

// const chatURL = process.env.REACT_APP_ISTANBUL_URL + "/chat"
const chatURL = '/chat'

export const postChatAPI = <T>(
    messages: Array<IMessage>,
    index: string,
    chat_type: string
): Promise<AxiosResponse<T>> => {

    axios.defaults.baseURL = chatURL
    return axios.post(
        "/",
        {messages, index, chat_type},
    )
}


export const getAllowedChatTypesAPI = (): Promise<AxiosResponse<Array<string>>> => {
    axios.defaults.baseURL = chatURL
    return axios.get(
        "/chat-types"
    )
}
